import { useTranslation } from 'react-i18next'
import './NotFound.scss'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'

export function NotFound() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/')
    }, 5000)

    return () => clearTimeout(timer)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="PageNotFoundComponent">
      <h1>{t('PAGE_NOT_FOUND')}</h1>
    </div>
  )
}
